const routes = [
    {
        path: '/class-schedule',
        component: () => import('../pages/Index.vue'),
        meta: {
            isAuthenticated: false,
            isPublic: true,
        }
    },
];

export default routes;
